import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ISystemMessage, SystemMessagesDictionary } from '../models/system-message';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import { Subscriber } from 'rxjs/Subscriber';
import { environment } from '../../../environments/environment';
@Injectable()
export class SystemMessagesService {

  private _systemMessagesDic: SystemMessagesDictionary = {};
  private _url: string = environment.apiUrl;
  //http://content.harel-employers/_vti_bin/webapi/SystemMessages
  constructor(private _httpClient: HttpClient) { }

  initilizeSystemMessages(systemCodes: string[]): void {
    this.getMessages(systemCodes).subscribe()
    //console.log(this._systemMessagesDic);
  }
  getMessages(systemCodes: string[]): Observable<SystemMessagesDictionary> {
    let missingSystemCodes: string[] = [];
    let alreadyCached: SystemMessagesDictionary = {};
    systemCodes.forEach(systemCode => {
      if (this._systemMessagesDic[systemCode] == null) {
        missingSystemCodes.push(systemCode);
      } else
        alreadyCached[systemCode] = this._systemMessagesDic[systemCode];
    });
    if (missingSystemCodes.length > 0) {
      let params = new HttpParams()
      params = params.append('returnDefault', 'false');
      missingSystemCodes.forEach(systemCode => {
        params = params.append('msgCode', systemCode);
      });
      return this._httpClient.get<SystemMessagesDictionary>(this._url, { params })
        .map(dic => {
          if (missingSystemCodes.length == 1) {
            this._systemMessagesDic[missingSystemCodes[0]] = <any>dic;
            alreadyCached[missingSystemCodes[0]] = <any>dic;
            return alreadyCached;
          }
          else {
            this._systemMessagesDic = { ...this._systemMessagesDic, ...dic };
            return { ...dic, ...alreadyCached };
          }
        })
    }
    else {
      return Observable.create(observer => observer.next(this._systemMessagesDic));
    }
  }
  getMessage(msgCode: string, fetch: boolean = true): ISystemMessage {
    if (this._systemMessagesDic[msgCode] == null) {
      if (fetch) {
        let params = new HttpParams()
        params = params.append('returnDefault', 'false');
        params = params.append('msgCode', msgCode);
        this._httpClient.get<ISystemMessage>(this._url, { params }).subscribe(
          msg => this._systemMessagesDic[msgCode] = msg
        );
      }
      return null;
    }
    else {
      return this._systemMessagesDic[msgCode];
    }
  }
}
